<template>
    <div>
        <ValidationObserver ref="formModalValidate">
           <b-row>
                <b-col cols="12" md="6">
                    <ValidationProvider name="student_club_id" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club_name')">
                            <student-club-selectbox :validateError="errors[0]"
                                                    v-model="form.student_club_id"
                                                    @club-selected="handleClubSelection"
                                                    :state="errors[0] ? false : null">
                            </student-club-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="academic_year" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('academic_year')">
                            <academic-years-selectbox v-model="form.academic_year">
                            </academic-years-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="start_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('start_date')">
                            <select-date :is-time="true" v-model="form.start_date" :validation-error="errors[0]" :time="true"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="end_date" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('end_date')">
                            <select-date :is-time="true" v-model="form.end_date" :validation-error="errors[0]" :time="true"/>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox v-model="form.status" code="student_club_president_application_statuses" :validate-error="errors[0]"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button
                @click="createForm"
                type="button"
                :disabled="formLoading"
                variant="primary"
                class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox.vue";
    import StudentClubSelectbox from "@/components/interactive-fields/StudentClubSelectbox.vue";
    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubService from "@/services/StudentClubService";

    export default {
        components: {
            ValidationProvider,
            ValidationObserver,
            ParameterSelectbox,
            StudentClubSelectbox
        },
        data() {
            return {
                formLoading: false,
                form: {
                  //
                }
            }
        },
        methods: {
            async createForm() {
                this.formLoading = true
                const isValid = await this.$refs.formModalValidate.validate()
                if (isValid) {
                    StudentClubService.storePresident(this.form)
                                    .then((response) => {
                                        this.$toast.success(this.$t("api." + response.data.message));
                                        this.$emit("createFormSuccess")
                                        this.formLoading = false
                                    })
                                    .catch((error) => {
                                        this.formLoading = false
                                        this.showErrors(error, this.$refs.formModalValidate)
                                    })
                } else {
                    this.formLoading = false
                }
            },
            handleClubSelection(clubData) {
                if (clubData && clubData.dues) {
                    this.form.dues = parseFloat(clubData.dues)
                } else {
                    this.form.dues = 0;
                }
            },
        }
    }
</script>
